import React from 'react';
import Tabs from '../Tabs';

const Page = () => (
  <div className="policies-page">
    <Tabs />
  </div>
);

export default Page;
